import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { BaseSiteService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { SharedService } from 'src/app/shared/services/shared.service';
import { ResourcesService } from '../resources.service';

@Component({
  selector: 'app-notification-bar',
  templateUrl: './notification-bar.component.html',
  styleUrls: ['./notification-bar.component.scss'],
})
export class NotificationBarComponent implements OnInit, OnDestroy {
  requestedItemList: any;
  baseSiteId: any;
  baseSub: Subscription;
  routerSub: Subscription;
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) private readonly data: any,
    private readonly service: ResourcesService,
    private readonly router: Router,
    private readonly snackbarRef: MatSnackBarRef<NotificationBarComponent>,
    private readonly sharedService: SharedService,
    private readonly baseSiteService: BaseSiteService
  ) {}

  ngOnInit(): void {
    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.requestedItemList = this.data;
    this.routerSub = this.router.events.subscribe((data) => {
      let value = this.sharedService.getSessionStorage(
        'isClickedBackToDashboard'
      );
      if (!value) this.snackbarRef.dismiss();
    });
  }
  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
    this.routerSub?.unsubscribe();
  }
  navigateRequestPage() {
    this.service.requestItemValues.next(this.requestedItemList);
    this.snackbarRef.dismiss();
    this.router.navigate(['resources/category/requestResourcespage']);
    this.sharedService.removeSessionStorage('isClickedBackToDashboard');
    localStorage.setItem(
      'requestedItemList',
      JSON.stringify(this.requestedItemList)
    );
  }
}
